<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<!-- <mat-spinner *ngIf="ntf.isLoading"></mat-spinner> -->
<app-spinner></app-spinner>